import moment from 'moment';

import { normalizeAccount } from './accountConversions';
import { graphQLToFormJobLocation } from './locationConversions';

export function graphQLToForm(values) {
  const account = values?.metadata?.qolAccount;
  return {
    ...values,
    exceptedQuantity: values?.exceptedQty,
    pickupDateTime: moment(values?.pickupDateTime?.scheduled),
    account: account ? normalizeAccount(account) : null,
    origin: graphQLToFormJobLocation(values?.origin || {}),
    destination: graphQLToFormJobLocation(values?.destination || {}),
  };
}
